
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import Testable from '@/mixins/Testable'
import DirectionsInput from '@/components/Map/Directions/Input.vue'
import TerminalCreator from '@/components/TerminalCreator.vue'
import TerminalDetails from '@/components/TerminalDetails.vue'
import GeoDirection from '@/directions/types/GeoDirection'
import FacilityDirection from '@/directions/types/FacilityDirection'
import { Terminal } from '@/models/Terminal'
import i18n from '@/i18n'

export const fetchWhenTerminal = async function (place: {
	facilityType: string
	facilityId: string
}): Promise<Terminal | null> {
	if (place && place instanceof FacilityDirection && place.facilityType === 'terminals' && place.facilityId) {
		return await Terminal.fetchLazy(place.facilityId)
	}
	return null
}
@Component({
	components: {
		DirectionsInput,
		TerminalCreator,
		TerminalDetails
	}
})
export default class LocationSelector extends Mixins(Testable) {
	@Prop({ required: false, default: null })
	value!: GeoDirection | FacilityDirection | null

	@Prop({ required: false, default: true })
	showCurrentLocationButton!: boolean

	@Prop({
		required: false,
		default: () => i18n.t('cargo.options.loading_place')
	})
	placeholder!: string

	@Prop({ required: false, default: 'loadingPlace' })
	inputType!: string

	@Prop({ default: null })
	canTransferLiquidBulk!: boolean | null

	@Prop({ required: false, default: true })
	includeAddresses!: boolean

	@Prop({ required: false, default: false })
	returnModel!: boolean

	openLocationCreator = false
	openTerminalDetails = false
	terminalCreatorEditMode = false

	terminal: Terminal | null = null

	@Watch('value')
	async updateTerminal(newVal) {
		this.terminal = await fetchWhenTerminal(newVal)
	}

	openTerminalCreatorForCreate() {
		this.terminalCreatorEditMode = false
		this.openLocationCreator = true
	}

	openTerminalCreatorForEdit() {
		this.openTerminalDetails = false
		this.terminalCreatorEditMode = true
		this.openLocationCreator = true
	}

	async setNewTerminalAsValue(terminal) {
		const direction = new FacilityDirection()
		direction.facilityId = terminal.getApiId() as string
		direction.facilityType = 'terminals'
		direction.text = terminal.getName()

		await this.emitValue(direction)
		this.openLocationCreator = false
	}

	async emitValue(facility) {
		let emitValue = facility
		if (this.returnModel && facility) {
			emitValue = await fetchWhenTerminal(facility)
		}
		this.$emit('input', emitValue)
	}
}
